import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCultureSelectedLocationCP,
  selectMeteorologyAgroWBCultureSelectedGroupCP,
  setLocationCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useLocations from '../../useLocations';

export default function useLocation() {
  const allLocations = useLocations().locations;

  const selectedGroup = useSelector(selectMeteorologyAgroWBCultureSelectedGroupCP);
  const availableLocations = allLocations
    ? allLocations.filter((l) => l.groupId === selectedGroup)
    : [];

  const selectedLocation = useSelector(selectMeteorologyAgroWBCultureSelectedLocationCP);
  const setLocation = (l: number) => {
    store.dispatch(setLocationCP(l));
  };

  return {
    availableLocations,
    selectedLocation,
    setLocation,
  };
}
